import type { PixelData, BoardSize, BoardConfig, BeadColor } from '@pindd/types'
import { findClosestColor } from './color-match'

export function adaptToBoard(
  pixelData: PixelData,
  boardSize: BoardSize,
  colorLibrary: BeadColor[]
): BoardConfig {
  const grid: (string | null)[][] = []

  for (let y = 0; y < boardSize.height; y++) {
    const row: (string | null)[] = []
    for (let x = 0; x < boardSize.width; x++) {
      if (y < pixelData.height && x < pixelData.width) {
        const hex = pixelData.pixels[y][x]
        const matched = findClosestColor(hex, colorLibrary)
        row.push(matched.id)
      } else {
        row.push(null)
      }
    }
    grid.push(row)
  }

  return { size: boardSize, grid }
}
